const breakpoint = {
  miniMobile: 575.98,
  mobileMax: 767.98,
  ipad: 1039.98,
  hdDesktop: 1199,
};
const basicColor = {
  black: "#000000",
  woodsmoke: "#18181B",
  blue: "#0044CC",
  silver: "#C4C4C4",
  lightBlue: "#D6E4FF",
  yellow: "#FCD420",
  stormGray: "#74788B",
  darkerGrey: "#7E839A",
  grey: "#E4E6F0",
  mercury: "#E5E5E5",
  whisper: "#F5F5FA",
  white: "#FFFFFF",
};

export const theme = {
  navBar: {
    color: {
      black: "#000000",
      white: "#FFFFFF",
    },
  },
  movieBanner: {
    color: {
      black: "#000000",
      white: "#FFFFFF",
    },
  },
  color: {
    black: "#000000",
    woodsmoke: "#18181B",
    blue: "#0044CC",
    silver: "#C4C4C4",
    lightBlue: "#D6E4FF",
    yellow: "#FCD420",
    stormGray: "#74788B",
    darkerGrey: "#7E839A",
    grey: "#E4E6F0",
    mercury: "#E5E5E5",
    whisper: "#F5F5FA",
    white: "#FFFFFF",
  },
  basicColor,
  breakpoint,
};
export const darkTheme = {
  navBar: {
    color: {
      black: "#EEEEEE",
      white: "#FFFFFF",
    },
  },
  movieBanner: {
    color: {
      black: "#EEEEEE",
      white: "#000000",
    },
  },
  color: {
    black: "#EEEEEE",
    woodsmoke: "#E7E7E4",
    blue: "#ffbb33",
    silver: "#3b3b3b",
    lightBlue: "#291b00",
    yellow: "#032bdf",
    stormGray: "#8b8774",
    darkerGrey: "#817c65",
    grey: "#1b190f",
    mercury: "#1a1a1a",
    whisper: "#0a0a05",
    white: "#000000",
  },
  basicColor,
  breakpoint,
};
